import React from 'react'

export const VentaCartaComanda = React.forwardRef((props, ref) => {
  const { getSell } = props

  return (
    <div ref={ref} style={{ textAlign: 'center', marginLeft: '2rem', marginRight: '2rem' }} className='ticket-modal-quotation' >
      <div style={{ textAlign: 'left' }}>
        {
          getSell?.sell_invoice?.fel_hondura ?
            <>
              <p>{`Empresa: ${getSell?.company ? getSell.company : getSell?.store?.company?.name}`}</p>
              <p>{`Rtn: ${getSell?.sell_invoice?.fel_hondura.rtn}`}</p>
              <p>{`Razon social: ${getSell?.sell_invoice?.fel_hondura.reason}`}</p>
              <p>{`Nombre comercial: ${getSell?.sell_invoice?.fel_hondura.tradename}`}</p>
              <p>{`Direccion: ${getSell?.sell_invoice?.fel_hondura.address}`}</p>
            </> :
            <>
              <p style={{ fontWeight: 'bolder' }}>{`Empresa: ${getSell?.company ? getSell.company : getSell?.store?.company?.name}`}</p>
              <p style={{ fontWeight: 'bolder' }}>{`Nit: ${getSell?.nit ? getSell.nit : getSell?.store?.company?.nit}`}</p>
              <p style={{ fontWeight: 'bolder' }}>{`Direccion: ${getSell?.store?.company?.address}`}</p>
            </>
        }
        <p style={{ fontWeight: 'bolder' }}>{`Tienda: ${getSell?.store?.name ? getSell?.store?.name : getSell?.store?.name}`}</p>
        <br></br>
      </div>
      <br></br>
      {getSell.store.company.country.name === 'Honduras' ? <></> : <p>TICKET DE VENTA</p>}
      <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <p style={{ fontWeight: 'bolder' }}>{`Venta No.:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Fecha:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Cliente:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Nit:`}</p>
        </div>
        <div>
          <p>{`${getSell?.id}`}</p>
          <p>{`${getSell?.date}`}</p>
          <p>{`${getSell?.client.name}`}</p>
          <p>{`${getSell?.client.nit}`}</p>
        </div>
        <div>
          <br></br>
        </div>
        <div style={{ textAlign: 'right' }}></div>
      </div>
      <table className='ticket-modal-quotation' style={{ width: '-webkit-fill-available' }}>
        <thead style={{ borderBottom: '2px solid rgba(0, 0, 0, 0.65)', borderTop: '2px solid rgba(0, 0, 0, 0.65)' }}>
          <tr>
            <th>{`Código`}</th>
            <th>{`Producto`}</th>
            <th>{`Cantidad`}</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const details = getSell?.sell_details || []
            const sorted = [...details].sort((a, b) => (a.item_line ?? 0) - (b.item_line ?? 0))

            // Agrupado por combo_instance_id, no por orden de impresión.
            const comboGroups = []
            const comboGroupByInstance = {}
            const looseItems = []
            sorted.forEach((data) => {
              if (!data.combo_instance_id) {
                looseItems.push(data)
                return
              }
              let group = comboGroupByInstance[data.combo_instance_id]
              if (!group) {
                group = { instanceId: data.combo_instance_id, name: '', items: [], extras: [] }
                comboGroupByInstance[data.combo_instance_id] = group
                comboGroups.push(group)
              }
              // el extra no trae presentation_combo, se toma el nombre de otra fila de la instancia
              if (data.presentation_combo?.description && !group.name) {
                group.name = data.presentation_combo.description
              }
              if (data.is_combo_extra) group.extras.push(data)
              else group.items.push(data)
            })

            const renderItemRow = (data, indent) => (
              <tr key={data.id} style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                <td>{`${data.presentation_id}`}</td>
                <td style={{ display: 'flex', textTransform: 'none', paddingLeft: indent ? 12 : 0 }}>{data?.presentation?.description?.substring(0, 40)}</td>
                <td>{`${data.quantity}`}</td>
              </tr>
            )

            return (
              <>
                {comboGroups.map((group) => (
                  <React.Fragment key={group.instanceId}>
                    <tr style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                      <td colSpan={3} style={{ textAlign: 'left', fontWeight: 'bolder', paddingTop: 6 }}>
                        {`Combo: ${group.name}`}
                      </td>
                    </tr>
                    {group.items.map((data) => renderItemRow(data, true))}
                    {group.extras.length > 0 && (
                      <>
                        <tr style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                          <td colSpan={3} style={{ textAlign: 'left', fontWeight: 'bolder', fontStyle: 'italic', paddingLeft: 12, paddingTop: 4 }}>
                            {'Extras:'}
                          </td>
                        </tr>
                        {group.extras.map((data) => renderItemRow(data, true))}
                      </>
                    )}
                  </React.Fragment>
                ))}
                {looseItems.map((data) => renderItemRow(data, false))}
              </>
            )
          })()}
        </tbody>
      </table>
    </div >
  );
});